import { render } from "./ImageGallary.vue?vue&type=template&id=0ae47f6a&scoped=true"
import script from "./ImageGallary.vue?vue&type=script&lang=js"
export * from "./ImageGallary.vue?vue&type=script&lang=js"

import "./ImageGallary.vue?vue&type=style&index=0&id=0ae47f6a&scoped=true&lang=css"

import exportComponent from "G:\\MET-CS601-Term-Project\\cs601-term-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae47f6a"]])

export default __exports__